import { BgImgWrapper } from "./styled";
import Dragon from "./Dragon";
import BarContainer from "./BarContainer";
import Rocket from "./Rocket";
import BoxContainer from "./BoxContainer";
import Kitchen from "./Kitchen";
import Igloo from "./Igloo";

const InteractiveImage = () => {
  return (
    <>
      <BgImgWrapper>
        <Dragon />
        <BarContainer />
        <Rocket />
        <BoxContainer />
        <Kitchen />
        <Igloo />
      </BgImgWrapper>
    </>
  );
};

export default InteractiveImage;
